import React from "react";
import Collapsible from "react-collapsible";
import ReactTooltip from "react-tooltip";
import { _tooltipper } from "../../utils/prehab";
import { Link } from "react-router-dom";

const categoryTooltips = {
  foundation:
    "Foundations: The exercises chosen are low load and low velocity movements. Our goal is to ensure proper motor patterns, biomechanics and to develop functional range of motion. Athletes need to demonstrate full or functional range of motion (ROM) motor control unloaded or with light load to decrease injury likelihood.",
  prime:
    "Prime: After building a sound foundation of movement, we begin to load the system in a moderate velocity setting. The focus is on increasing biomechanical strength and increasing movement skill. The main goal of the program is to prepare for more advanced movements via breakdown exercises that segment the movement. There is a high allocation of time focused on repetition and progressive motor loading. Our goal is to ensure that all elements of advanced movements are mastered, in preparation for exercises used in the Elite phase.",
  elite:
    "Elite: Given adequate control under load that has been built up through the prime program, we move into more advanced movements that demand more skill and control. Exercises include high velocity and high load movements. Rate of force development is a primary focus in this phase.",
};

//the last 4 vids are uncategorized so i stuck them here in squats foundations...
const foundObj = {
  "Hamstring Eccentric Slider": {
    url: "https://www.youtube.com/embed/shVZP0NZAYk?rel=0",
  },
  "Hamstring Curls with Sliders": {
    url: "https://www.youtube.com/embed/jxCyP36MjSY?rel=0",
  },
  "Single Leg Hamstring Swissball Curl": {
    url: "https://www.youtube.com/embed/ZeA9Oe1i1Ck?rel=0",
  },
  "Body Weight Hip Hinge": {
    url: "https://www.youtube.com/embed/ZKdikvZ_2OA?rel=0",
  },
  "High Rack Pull": {
    url: "https://www.youtube.com/embed/jx3TGXxYsTc?rel=0",
  },
  "Low Rack Pull": {
    url: "https://www.youtube.com/embed/e_jzo8y4RNc?rel=0",
  },
  "Kettle Bell Deadlift": {
    url: "https://www.youtube.com/embed/s3GSKfWdY6o?rel=0",
  },

};

const primeObj = {
  "Multi-Directional Jumps": {
    url: "https://www.youtube.com/embed/QXLlfYkG2sU?rel=0",
  },
  "Depth Jump": {
    url: "https://www.youtube.com/embed/a3HZ16BNy1s?rel=0",
  },
  "Barbell Box Squat": {
    url: "https://www.youtube.com/embed/AbA7GfK-qs0?rel=0",
  },
  "Barbell Back Squat": {
    url: "https://www.youtube.com/embed/X4JLljbG5hw?rel=0",
  },
  "Barbell Front Squat": {
    url: "https://www.youtube.com/embed/W3dSkq_8klw?rel=0",
  },
  "Barbell Deadlift": {
    url: "https://www.youtube.com/embed/w48vYjweock?rel=0",
  },
  "Depth Single Leg Box Jump": {
    url: "https://www.youtube.com/embed/46OyZdr46nU?rel=0",
  },
  "Single Leg Box Down Jump": {
    url: "https://www.youtube.com/embed/-pjs62uHgE0?rel=0",
  },
  "Lateral Box Down Jumps": {
    url: "https://www.youtube.com/embed/bypYeIOa_w8?rel=0",
  },
  "Lateral Box Jumps": {
    url: "https://www.youtube.com/embed/iCCwoIWgQkM?rel=0",
  },

  "Barbell Romanian Deadlift": {
    url: "https://www.youtube.com/embed/k8RkT2lDK1s?rel=0",
  },
  "Single Leg Squat Jumps": {
    url: "https://www.youtube.com/embed/WYK-U4Ul6q8?rel=0",
  },
};

const eliteObj = {
  "Tempo Squats": {
    url: "https://www.youtube.com/embed/bfJgSnWQW84?rel=0",
  },
  Deadlift: {
    url: "https://www.youtube.com/embed/JUunjc0qJMg?rel=0",
  },
  "Zercher Squat": {
    url: "https://www.youtube.com/embed/bUIJMvXn9BA?rel=0",
  },
  "Depth Jump to Lateral Jump": {
    url: "https://www.youtube.com/embed/mWQP8uEXJ0g?rel=0",
  },
  "Depth Jump to Lateral Shuffle": {
    url: "https://www.youtube.com/embed/ok7uFs7H0QI?rel=0",
  },
  "Hamstring Tantrums": {
    url: "https://www.youtube.com/embed/O5TfIL504zM?rel=0",
  },
  "Nordic Hamstring Curl": {
    url: "https://www.youtube.com/embed/bU1_VqGy9Sk?rel=0",
  },
  "Raised Power Clean Pull": {
    url: "https://www.youtube.com/embed/4R5NY7dcVDo?rel=0",
  },
  "Raised Power Clean": {
    url: "https://www.youtube.com/embed/aWlMUKGVqIo?rel=0",
  },
  "Power Clean Pull": {
    url: "https://www.youtube.com/embed/fDCDjbbUJyU?rel=0",
  },
  "Power Clean": {
    url: "https://www.youtube.com/embed/lFAmxTVC8rc?rel=0",
  },
  "Resistance Banded Squats": {
    url: "https://www.youtube.com/embed/xqcHrhoLaNM?rel=0",
  },
  "Longitudinal Hex Bar Deadlift": {
    url: "https://www.youtube.com/embed/X6qzvgXN7ik?rel=0",
  },
  "Loaded Squat Jumps": {
    url: "https://www.youtube.com/embed/TBzec_mClNQ?rel=0",
  },
};

const Med_Epi_Prevention = (props) => {
  //this function is used to create the nested dropdown based on the large objects above
  const _vidListMaker = (level, cName, vidObj) => {
    const vids = Object.keys(vidObj).map((title, i) => {
      const curVid = vidObj[title];
      return (
        <Collapsible
          key={i}
          trigger={title}
          classParentString={`${cName}-video Collapsible`}
        >
          <p className="intro-vid">
            <iframe
              title={title}
              width="560"
              height="315"
              src={curVid["url"]}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </p>
        </Collapsible>
      );
    });
    // adds tooltips for desktop devices for hovering over the exercise category
    let trigger;
    if (props.width < 992) {
      trigger = (
        <div className="collapsible-trigger">
          <span>{level}</span>
        </div>
      );
    } else {
      trigger = (
        <div
          className="collapsible-trigger"
          data-tip={categoryTooltips[cName]}
          data-for="categ"
        >
          <span>{level}</span>
        </div>
      );
    }
    return (
      <Collapsible
        trigger={trigger}
        classParentString={`${cName}-video Collapsible`}
      >
        {vids}
      </Collapsible>
    );
  };
  const introVids = _vidListMaker("Foundations", "foundation", foundObj);
  const primeVids = _vidListMaker("Prime", "prime", primeObj);
  const eliteVids = _vidListMaker("Elite", "elite", eliteObj);

  const { width } = props;

  return (
    <div>
      <div className="title-margins">
        <h2>Prehabilitation Exercises to Reduce Risk of Hamstring Strain</h2>
      </div>
      <div className="card p-1">
        {introVids}
        {primeVids}
        {eliteVids}
        <ReactTooltip
          place="bottom"
          className="tooltip-categ"
          effect="solid"
          id="categ"
        />
      </div>
      <div className="card">
        <p className="mb-0">
          The videos above are examples of exercises that can reduce your chance
          of injury. For advice on personalizing your strength program based on
          your genetic tests, you can schedule a strength consultation{" "}
          <Link to="/consultations">here</Link>.
        </p>
      </div>
      <div className="card">
        <p>
          One of the most important strategies is progressive strength training,
          especially emphasizing eccentric hamstring loading (lengthening
          contractions). Exercises like slow, controlled squats, split squats,
          Nordic hamstring exercise (eccentric knee flexion), and deceleration drills increase the muscle–tendon unit’s ability to tolerate high-speed stretch, which is when most strains occur.
        </p>
        <p>
          Flexibility and range-of-motion work can help, especially if there are
          large side-to-side asymmetries or restricted hip flexion/knee
          extension. However, excessive static stretching immediately before
          explosive activity is less helpful; mobility work is better placed
          earlier in the day or after training.
        </p>
        <p>
          Warm-up quality matters. Dynamic warm-ups that increase muscle
          temperature and neural activation (e.g., progressive sprints, mobility
          drills, activation exercises) reduce passive stiffness and improve
          force control. Cold muscles are stiffer and more strain-prone.
        </p>
        <p>
          Load management is critical. Sudden spikes in sprinting volume,
          high-speed running, kicking repetitions, or competition density
          strongly increase strain risk. Gradual progression and monitoring
          weekly changes in sprint distance, intensity, and training volume help
          keep tissue stress within adaptive ranges. Avoiding sharp increases
          after rest periods or injury layoff is especially important.
        </p>
      </div>
      <ReactTooltip
        place="top"
        className="tooltip-axgen"
        effect="solid"
        id="exercise-types"
      />
    </div>
  );
};

export default Med_Epi_Prevention;
